module.exports = __webpack_public_path__ + "img/fbIcon.849fa9d1.svg";